import {STORY} from './Types';
import axios from "axios/index";
import {API_URL} from "../config/config";
import {getAuthToken, getAuthUserDetails} from "./Common";

export function getStory(storyId, callback) {

  const authToken = getAuthToken();
  const userDetails = getAuthUserDetails();

  return (dispatch) => {
      axios.get(`${API_URL}deck/story/${storyId}`, {
          headers: {Authorization: `Bearer ${authToken}`}
      }).then((response) => {         
        callback(response);
        dispatch({
            type    : STORY,
            payload : response.data
        })
    }).catch(function (error) {     
        callback(error.response);
    });
  }
}



// WEBPACK FOOTER //
// ./actions/Story.js